import { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Alert, AlertTitle } from '../../../../../node_modules/@material-ui/lab/index'
import React from 'react'
import Swal from 'sweetalert2'

import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck';
import { useStoreState } from 'store/index'
import { qosFormVersions } from '../../../../api/index'
import userAPI from '../../../../api/user'

export default function StandardReportStep1({
	reportMethod,
	reportVersion,
	onChangeRadio,
	fixedReportTypeRadioValue,
	mobileReportTypeRadioValue,
	onChangeReportType,
	setVersion,
	userOperatorProfile,
	hasEverSubmitedForm,
	isNewForm,
	onChangeIsContinueRadio,
	continueFormSubmittedType = {
		isFixed: true,
		isMobile: true,
	},
	currentHeadData,
	userOverride,
}) {
	const userStore = useStoreState(s => s.userModel.user)
	const user = userOverride || userOperatorProfile || userStore
	const [formPerType, setFormPerType] = useState({
		fixed: false,
		mobile: false,
	})
	const [formVersions, setFormVersions] = useState([])

	useEffect(() => {
		const fetchVersions = async () => {
			const res = await qosFormVersions.getQoSFormVersions()
			if (res && res.data) {
				setFormVersions(res.data)
			}
		}
		fetchVersions()
	}, [])
	// console.log('user', user)
	// console.log('currentHeadData', currentHeadData)
	var rejectReason = currentHeadData?.rejectReason || ''
	var currentReportStatus = currentHeadData?.status || 1
	var isSendReportDisabled = false
	if (currentReportStatus === 2 || currentReportStatus === 3 || currentReportStatus === 4 || currentReportStatus === 5) {
		isSendReportDisabled = true
	} else {
		isSendReportDisabled = false
	}
	useEffect(() => {
		window.scrollTo(0, 0)
		if (rejectReason && currentReportStatus === 1) {
			Swal.fire({
				title: 'รายละเอียดการแก้ไขจากผู้อนุมัติการส่งข้อมูล',
				html: `<div style="white-space: pre-wrap;">${rejectReason}</div>`,
				showCloseButton: true,
				icon: 'info',
			})
		} else if (currentReportStatus === 2 || currentReportStatus === 3 || currentReportStatus === 4) {
			// Swal that can close
			Swal.fire({
				title: 'รายงานมาตรฐานของท่านอยู่ระหว่างการตรวจสอบ',
				text: 'โปรดรอการตรวจสอบและอนุมัติจากผู้อนุมัติการส่งข้อมูล และสำนักงาน กสทช.',
				icon: 'info',
				showConfirmButton: true,
				showCloseButton: true,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				width: '800px',
			})

		} else if (currentReportStatus === 5) {
			Swal.fire({
				title: 'รายงานของท่านได้อนุมัติจากสำนักงาน กสทช. แล้ว',
				text: 'ในปีและไตรมาสปัจจุบัน ท่านได้ส่งรายงานเรียบร้อยแล้ว โปรดรอส่งรายงานอีกครั้งในไตรมาสถัดไป',
				icon: 'success',
				showConfirmButton: true,
				showCloseButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				width: '800px',
			})
		}
	}, [currentHeadData])

	useEffect(() => {
		const fetchDatasetOptions = async () => {
			let temp = {
				fixed: true,
				mobile: true,
			}

			// Admin overrides via userOverride prop bypass the API
			// The admin page passes an object with 'operatorUserQOSType'.
			// The user page passes an object with only 'isUseReport1_1_2', so we must check for operatorUserQOSType.
			if (userOverride && userOverride.operatorUserQOSType) {
				let qosList = []
				if (user?.operatorUserQOSTypes?.length > 0) {
					user.operatorUserQOSTypes.forEach(item => {
						if (item?.operatorAccess?.operator?.operatorQOS) {
							qosList = [...qosList, ...item.operatorAccess.operator.operatorQOS]
						}
					})
				}

				if (!qosList || qosList.length === 0) {
					if (user?.operatorAccess?.length > 0) {
						user.operatorAccess.forEach(access => {
							if (access?.operatorUserQOSType && access.operatorUserQOSType.length > 0) {
								qosList = [...qosList, ...access.operatorUserQOSType]
							} else if (access?.operator?.operatorQOS) {
								qosList = [...qosList, ...access.operator.operatorQOS]
							}
						})
					}
				}

				if (!qosList || qosList.length === 0) {
					qosList = user?.operatorUserQOSType || user?.operatorQOS || user?.operatorUserQOSTypes || []
				}

				if (qosList && qosList.length > 0) {
					temp = {
						fixed: false,
						mobile: false,
					}
					qosList.forEach(item => {
						const id = item.qosTypeID || item.QOSTypeID || item.id
						if (id === 1) temp.mobile = true
						if (id === 2) temp.fixed = true
					})
				}
				setFormPerType(temp)
			} else {
				// Normal user: fetch directly from database
				// Extract operatorId from the user profile if they have multiple operators, falling back to empty string
				const currentOperatorId = user?.operatorAccess?.[0]?.operatorID || user?.operatorID || ''
				const res = await userAPI.getMyQosTypes(currentOperatorId)
				if (res && res.data) {
					setFormPerType({
						fixed: res.data.fixed,
						mobile: res.data.mobile
					})
				} else {
					// Fallback if API fails, default to hiding both to prevent unauthorized input
					setFormPerType({ fixed: false, mobile: false })
				}
			}
		}

		fetchDatasetOptions()
	}, [user, userOverride])

	// Check for mismatch between current QOS and Draft QOS
	const [isMismatch, setIsMismatch] = useState(false)

	useEffect(() => {
		if (hasEverSubmitedForm && currentReportStatus < 4) {
			const mismatch = (formPerType.fixed !== continueFormSubmittedType.isFixed) ||
				(formPerType.mobile !== continueFormSubmittedType.isMobile);
			setIsMismatch(mismatch);

			if (mismatch && isNewForm === 'n') {
				// Force to New Form
				if (onChangeIsContinueRadio) {
					onChangeIsContinueRadio({ target: { value: 'y' } })
				}
			}
		} else {
			setIsMismatch(false)
		}
	}, [formPerType, continueFormSubmittedType, hasEverSubmitedForm, currentReportStatus, isNewForm, onChangeIsContinueRadio])



	return (
		<>
			<Alert severity="info" className="mb-5 w-full" style={{ whiteSpace: "normal" }}><AlertTitle>โปรดเลือก ชุดข้อมูลการส่งรายงาน ให้ตรงกับประกาศปีปัจจุบันทุกครั้งที่ท่านกรอกข้อมูลใหม่ <br />ในกรณีที่ท่านต้องการดำเนินการกรอกข้อมูต่อจากเดิมให้เลือก ชุดข้อมูลการส่งรายงาน ให้ตรงกับที่เคยดำเนินการไว้<br />หลังจากวันที่ 1 เมษายน พ.ศ. 2568 เป็นต้นไป โปรดใช้ชุดข้อมูลการส่งรายงาน แบบฟอร์มประกาศปี 2568 ในการส่งรายงาน</AlertTitle></Alert>

			<Grid className="flex items-center justify-center ">
				<Card className="flex flex-col h-auto p-4 w-full gap-y-2 border border-t-4 border-card_top_border border-l-0 border-r-0 border-b-0">
					<Grid className="flex flex-row font-bold text-sm items-center">
						<PlaylistAddCheck style={{ fontSize: 22 }} className="mr-1" />
						<Grid className="text-card_header_color">
							เลือกรูปแบบการส่งรายงาน
						</Grid>
					</Grid>
					<Grid>
						<Divider />
					</Grid>
					<Grid>รูปแบบการส่งรายงาน</Grid>
					<RadioGroup
						row
						value={reportMethod}
						onChange={onChangeRadio}
						defaultChecked={false}>
						<FormControlLabel
							value="web-form"
							control={<Radio />}
							label="Web Form"
							disabled={isSendReportDisabled}
						/>
						<FormControlLabel
							value="upload"
							control={<Radio />}
							label="Upload"
							disabled={isSendReportDisabled}
						/>
					</RadioGroup>
					<Grid>*ชุดข้อมูลการส่งรายงาน</Grid>

					<Grid className="grid grid-cols-1 md:grid-cols-2 w-5/5 md:w-3/5 xl:w-2/5">
						{ /*drop down list of version have 2 version now and selected lastest version */}
						<Select
							value={reportVersion}
							onChange={e => setVersion(e.target.value)}
							variant="outlined"
							className="w-full"
							disabled={isSendReportDisabled}
						>
							{formVersions.map((v) => (
								<MenuItem key={v.id} value={v.version}>{v.versionName}</MenuItem>
							))}
						</Select>

					</Grid>
					<Grid>ชุดข้อมูล</Grid>
					<Grid className="grid grid-cols-1 md:grid-cols-2 w-5/5 md:w-3/5 xl:w-2/5">
						{formPerType.fixed && (
							<FormControlLabel
								checked={
									isNewForm === 'y'
										? fixedReportTypeRadioValue
										: continueFormSubmittedType.isFixed
								}
								disabled={isNewForm === 'n' || isSendReportDisabled || reportMethod === 'upload'}
								control={<Checkbox />}
								onChange={e => onChangeReportType(1, e.target.checked)}
								label={'ชุดข้อมูลแบบประจำที่'}
							/>
						)}
						{formPerType.mobile && (
							<FormControlLabel
								checked={
									isNewForm === 'y'
										? mobileReportTypeRadioValue
										: continueFormSubmittedType.isMobile
								}
								onChange={e => onChangeReportType(2, e.target.checked)}
								disabled={isNewForm === 'n' || isSendReportDisabled || reportMethod === 'upload'}
								control={<Checkbox />}
								label={'ชุดข้อมูลแบบเคลื่อนที่'}
							/>
						)}
					</Grid>
					{hasEverSubmitedForm && (
						<Grid className="text-red-500">
							{isMismatch ? 'ระบบตรวจพบว่า คุณเคยกรอกรายงานมาตรฐาน แต่ระบบตรวจพบว่าประเภทของรายงานของคุณไม่ตรงกับแบบร่างเดิม จึงจำเป็นต้องกรอกใหม่เท่านั้น' : 'ระบบตรวจพบว่า คุณเคยกรอกรายงานมาตรฐาน ต้องการที่จะดำเนินการต่อหรือไม่?'}
						</Grid>
					)}
					{hasEverSubmitedForm && (
						<RadioGroup row value={isNewForm} onChange={onChangeIsContinueRadio}>
							<FormControlLabel
								value={'n'}
								disabled={isSendReportDisabled || isMismatch}
								control={<Radio />}
								label="ดำเนินการต่อ"
							/>
							<FormControlLabel
								value={'y'}
								disabled={isSendReportDisabled}
								control={<Radio />}
								label="กรอกใหม่"
							/>
						</RadioGroup>
					)}
				</Card>
			</Grid>
		</>
	)
}
